module.exports = __webpack_public_path__ + "static/media/right-arrow-disabled.801235ae.svg";